import * as React from 'react';

import { MenuItem } from './menu-item';

type Props = {
  topic: {
    title: string;
    bgImage: string;
    items: Array<{
      name: string;
      description?: string;
      price: number;
    }>;
  };
  onSelect?: () => void;
  onClose?: () => void;
};

export class MenuTopic extends React.PureComponent<Props> {
  public render() {
    const { topic, onSelect, onClose } = this.props;
    const bgImage = require(`../../../../assets/${topic.bgImage}.jpg`);

    return (
      <div className="menu-topic" onClick={onSelect}>
        <div className="menu-topic__title">
          {/* <img className="menu-topic__bg" src={require(`../../../../assets/${topic.bgImage}.jpg`)} /> */}
          <div className="menu-topic__bg" style={{ backgroundImage: `url('${bgImage}')` }} />

          {topic.title}

          {
            onClose &&
            <button className="menu-topic__close" onClick={onClose}>
              <i className="material-icons">close</i>
            </button>
          }
        </div>

        <div className="menu-topic__items">
          {topic.items.map((item) => <MenuItem key={item.name} item={item} />)}
        </div>
      </div>
    );
  }
}
